import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-950/95 backdrop-blur-md shadow-[0_1px_0_0_rgba(255,255,255,0.05)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-9 h-9 flex items-center justify-center">
            <i className="ri-book-open-line text-2xl text-primary-500 group-hover:text-primary-400 transition-colors"></i>
          </div>
          <span className="text-xl font-heading font-bold text-foreground-100 group-hover:text-primary-400 transition-colors">
            韩漫网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/'
                ? 'text-primary-500'
                : 'text-foreground-300 hover:text-primary-400'
            }`}
          >
            首页
          </Link>
          <Link
            to="/category/all"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname.startsWith('/category')
                ? 'text-primary-500'
                : 'text-foreground-300 hover:text-primary-400'
            }`}
          >
            分类
          </Link>
          <Link
            to="/category/all?sort=hot"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/category/all' && location.search.includes('hot')
                ? 'text-primary-500'
                : 'text-foreground-300 hover:text-primary-400'
            }`}
          >
            热门排行
          </Link>
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/about'
                ? 'text-primary-500'
                : 'text-foreground-300 hover:text-primary-400'
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-background-700 transition-colors cursor-pointer" aria-label="搜索">
            <i className="ri-search-line text-foreground-300 text-lg"></i>
          </button>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-background-800 hover:bg-background-700 transition-colors cursor-pointer"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="菜单"
        >
          <i className={`text-foreground-300 text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-900 border-t border-background-700/50">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="py-2 text-foreground-200 text-sm font-medium hover:text-primary-400 transition-colors">首页</Link>
            <Link to="/category/all" className="py-2 text-foreground-200 text-sm font-medium hover:text-primary-400 transition-colors">分类浏览</Link>
            <Link to="/category/all?sort=hot" className="py-2 text-foreground-200 text-sm font-medium hover:text-primary-400 transition-colors">热门排行</Link>
            <Link to="/about" className="py-2 text-foreground-200 text-sm font-medium hover:text-primary-400 transition-colors">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}